//import 'babel-polyfill';
import "core-js/stable";
import * as Vue from 'vue'
//import Vue from 'vue';
import { h } from 'vue';
import App from './App.vue';
import { store } from './store';

let config = window.prospectusConf;
/*
let app = new Vue({
  el: '#prospectus-app',
  components: { App },
  store: store,
  render: 
  h => h(App, {
    props: {
      config: conf
    }
  })
})*/

const app = Vue.createApp({
    components: { App }, 
    render() {
        return h(App, {
            conf: config
        });
    }
});
app.use(store);
app.mount("#prospectus-app");